import { selectHasSelectedLegalEntity } from '@mkp/shared/util-router';
import { selectHasSelectedAccount } from '@mkp/account/state';
import { createSelector } from '@ngrx/store';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { layoutFeature } from './layout.reducer';

export const selectLayout = layoutFeature.selectLayoutStateState;
export const selectTopHeader = layoutFeature.selectTopHeader;
export const selectIsNavigationCollapsed = layoutFeature.selectIsNavigationCollapsed;
export const selectShowNavigation = createSelector(
  layoutFeature.selectHasNavigation,
  selectHasSelectedAccount,
  selectIsBoUser,
  selectHasSelectedLegalEntity,
  (hasNavigation, hasSelectedAccount, isBoUser, hasSelectedLegalEntity) =>
    // bo-user can always display a navigation but normal-users need to have a selected account to know their permisisons
    hasNavigation && (hasSelectedAccount || hasSelectedLegalEntity || !!isBoUser)
);
export const selectLeftBoxContent = createSelector(
  selectTopHeader,
  (state) => state.leftBoxContent
);
export const selectRightBoxContent = createSelector(
  selectTopHeader,
  (state) => state.rightBoxContent
);
export const selectLayoutElements = createSelector(selectLayout, (state) => ({
  hasBorders: state.hasBorders,
  hasNavigation: state.hasNavigation,
  hasTopHeader: state.topHeader.hasTopHeader,
  isNavigationCollapsed: state.isNavigationCollapsed,
  normalDocumentFlow: state.normalDocumentFlow,
  hasFooter: state.hasFooter,
}));
